export const NEWSLETTERS = {
    NEWS_LETTERS: 'newsletters',
    INSIGHTS: 'insights',
    LAW_ALERT: 'lawAlerts',
    LAW_ALERTS: 'law_alerts',
    LAW_UPDATES: 'law_updates',
    WHAT_MATTERS: 'hrNewsletter2',
    QUESTION_OF_THE_WEEK: 'hrNewsletter1',
    PRODUCT_UPDATES_NEWS_LETTER: 'mineralProductUpdatesNewsletter',
};

export const NEWSLETTERS_LABEL = {
    INSIGHTS: 'Insights from Mineral Intelligence™',
    LAW_ALERTS: 'Law Alerts',
};

export const NEWSLETTERS_TITLE =
    'This will affect ${affectedUsers} out of the ${allUsers} users you selected. Users who don’t receive newsletters will be unaffected.';

export const SUBSCRIPTION_INFO = {
    [NEWSLETTERS.LAW_ALERTS]: {
        LABEL: 'Law Alerts',
        DESCRIPTION:
            'Check the boxes below to subscribe to law alerts for federal and individual states. Dependent upon your available services, this may also include policy alerts.',
        LAW_ALERTS_NEW_DESCRIPTION:
            'Select the states you want to subscribe to in order to receive email alerts highlighting recent changes to federal and state employment laws.',
        TOOLTIP:
            'Law Alerts cover the most critical changes to federal and state employment laws. Note that these emails are intended to provide timely information on legislative changes.',
    },
    [NEWSLETTERS.LAW_UPDATES]: {
        LABEL: 'Law Updates',
        DESCRIPTION:
            'Select the states and law categories you want to subscribe to in order to receive notice of recent changes to our law summaries pages. Available options may vary depending on your subscribed services.',
        TOOLTIP:
            'Law Updates provide notice of substantive edits made to our law summaries pages due to recent changes in federal and state laws.',
    },
    [NEWSLETTERS.WHAT_MATTERS]: {
        LABEL: 'What Matters',
        DESCRIPTION: '',
        TOOLTIP:
            'What Matters is a monthly email newsletter that provides information on state and federal legislative changes from the previous month and highlights content created by our experts that is practical, timely, and user-friendly.',
    },
    [NEWSLETTERS.QUESTION_OF_THE_WEEK]: {
        LABEL: 'Question of the week',
        DESCRIPTION: '',
        TOOLTIP:
            'Question of the Week is a weekly email that provides a glimpse into an HR question we’ve received and the response from our HR Expert.',
    },
    [NEWSLETTERS.PRODUCT_UPDATES_NEWS_LETTER]: {
        LABEL: 'Newsletter: Mineral Product Updates',
        DESCRIPTION: '',
        TOOLTIP:
            'Mineral Product Updates informs users of new releases, enhancements, and other important product changes in the Mineral Platform.',
    },
    [NEWSLETTERS.INSIGHTS]: {
        LABEL: 'Insights',
        DESCRIPTION: '',
        TOOLTIP:
            'Subscribe to be notified of important events when changes are made to your company profile',
    },
};

export const SUBSCRIPTION_TITLE = 'Select the HR Communications you would like to receive by email';

export const GENERAL_SUBSCRIPTIONS_TITLE = 'General Subscriptions';
export const CUSTOM_SUBSCRIPTIONS_TITLE = 'Custom Subscriptions';
export const HR_COMMUNICATIONS_TITLE = 'HR Communications Email';
export const HR_COMMUNICATIONS_DESCRIPTION =
    'Select the HR Communications you would like to receive by email, from HR insights and legislative changes to product enhancements and important updates to your company profile.';
